import React from "react";
import { Text } from "..";
import CheckIcon from "src/img/new/green-check.svg";
import { AspectBox, AspectLabel,
    Wrapper, AspectGrid,
    AspectSelectableBox, AspectInnerBox,
    CheckmarkWrapper
} from "./ModalCrop.style";
/**
 * - Displays predefined aspect ratios (e.g., 16:9, 1:1, 4:5) with visual indicators.
 * - Allows the user to select an aspect ratio and sets it as the base aspect.
 * - Optionally triggers the orientation change to "landscape" if condition is meet.
 * - For detailed documentation, refer to the parent component where the logic and props are explained.
 */
export const AspectRatioSelector = ({
    aspectRatios,
    baseAspect,
    setBaseAspect,
    setOrientation,
    orientation,
}) => {
    const isAspectSelected = (w, h) => baseAspect.width === w && baseAspect.height === h;

    // Filter aspect ratios based on current orientation
    const filteredAspectRatios = aspectRatios.filter(({ width, height }) => {
        if (width === height) return orientation === "landscape"; // change to return true if 1:1 is neutral

        if (orientation === "landscape") {
            return width > height;
        } else if (orientation === "portrait") {
            return height > width; 
        }
        return true; 
    });

    return (
        <Wrapper>
            <Text family="Manrope" align="left" size="16px" weight="bold">
                Select Aspect Ratio
            </Text>
            <Text size="14px" family="Manrope" align="left">
                Choose from popular ratios like 9:16, 1:1, or 4:5 to format your media for different platforms.
            </Text>

            <AspectGrid>
                {filteredAspectRatios.map(aspectData => {
                    const { width, height, label } = aspectData;
                    const maxBoxSize = 38;
                    const boxWidth = width >= height ? maxBoxSize : Math.round((width / height) * maxBoxSize);
                    const boxHeight = width >= height ? Math.round((height / width) * maxBoxSize) : maxBoxSize;

                    return (
                        <AspectBox key={label}>
                            <AspectSelectableBox
                                isSelected={isAspectSelected(width, height)}
                                onClick={() => {
                                    setBaseAspect(aspectData);
                                    if (setOrientation && orientation) setOrientation(orientation);
                                }}
                            >
                                <AspectInnerBox width={boxWidth} height={boxHeight} />

                                {isAspectSelected(width, height) && (
                                    <CheckmarkWrapper>
                                        <img
                                            src={CheckIcon}
                                            alt="Selected"
                                            style={{
                                                width: "15px",
                                                height: "15px",
                                            }}
                                        />
                                    </CheckmarkWrapper>
                                )}
                            </AspectSelectableBox>
                            <AspectLabel>{label}</AspectLabel>
                        </AspectBox>
                    );
                })}
            </AspectGrid>
        </Wrapper>
    );
};
